<template>
  <v-card
    v-if="noPost"
    outlined
    max-width="900"
    class="post-card mb-3"
  >
    <v-card-text>投稿が存在しません。</v-card-text>
  </v-card>
  <v-card
    v-else-if="loader"
    outlined
    max-width="900"
    class="post-card mb-3"
    :class="{ 'show-count': showCount }"
  >
    <div class="d-flex">
      <v-list-item class="mr-auto">
        <v-skeleton-loader
          v-if="showUser"
          type="avatar"
          tile
          width="40"
          height="40"
          class="mr-3"
        />
        <v-list-item-content class="d-block">
          <v-skeleton-loader
            type="heading"
            tile
            height="14"
            class="ma-0"
          />
          <v-skeleton-loader
            v-if="showUser"
            type="text"
            tile
            width="100"
            height="14"
            class="ma-0 mt-2"
          />
        </v-list-item-content>
      </v-list-item>
      <v-divider vertical />
      <div class="d-flex">
        <v-btn
          text
          disabled
          class="post-card__play-btn text-center pa-0"
        >
          <v-icon size="20">
            fas fa-headphones-alt
          </v-icon>
        </v-btn>
      </div>
    </div>
    <template v-if="showCount">
      <v-divider />
      <div class="d-inline-flex align-center ml-4 mt-3">
        <v-icon
          small
          class="ml-0 mr-2"
        >
          fas fa-headphones-alt
        </v-icon>
        <v-skeleton-loader
          type="text"
          tile
          width="85"
          height="14"
          class="ma-0"
        />
        <v-icon
          small
          class="ml-5 mr-2"
        >
          far fa-star
        </v-icon>
        <v-skeleton-loader
          type="text"
          tile
          width="85"
          height="14"
          class="ma-0"
        />
      </div>
    </template>
  </v-card>
  <v-card
    v-else
    outlined
    max-width="900"
    min-height="62"
    class="post-card mb-3"
    :class="{ 'show-count': showCount }"
  >
    <div
      class="d-flex"
      @click="post.showExplanation = !post.showExplanation"
    >
      <v-list-item class="mr-auto">
        <v-btn
          v-if="showUser"
          fab
          text
          small
          :ripple="false"
          :to="{ name: 'user-page', params: { userId: post.uid } }"
          class="not-hover-btn pa-0 mr-3"
        >
          <v-list-item-avatar color="ma-0 grey lighten-4">
            <v-img
              v-if="post.photoURL"
              :src="post.photoURL"
            />
            <v-icon
              v-else
              size="20"
            >
              fa-user
            </v-icon>
          </v-list-item-avatar>
        </v-btn>
        <v-list-item-content class="post-card__content">
          <v-list-item-title class="body-2">
            {{ post.title }}
          </v-list-item-title>
          <v-list-item-subtitle v-if="showUser">
            {{ post.displayName }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <div class="d-flex align-center mr-3">
        <v-btn
          icon
          small
        >
          <v-icon small>
            {{ post.showExplanation ? 'fas fa-chevron-up' : 'fas fa-chevron-down' }}
          </v-icon>
        </v-btn>
      </div>
      <v-divider vertical />
      <div class="d-flex">
        <v-btn
          text
          :to="{ name: 'post', params: { postId: post.postId } }"
          class="post-card__play-btn text-center pa-0"
        >
          <div>
            <div>
              <v-icon
                size="20"
                :color="!post.playingTime ? 'red' : ''"
              >
                fas fa-headphones-alt
              </v-icon>
            </div>
            <div
              v-if="post.playingTime"
              class="caption"
            >
              {{ $_convertPlayTime(post.playingTime) }}
            </div>
          </div>
        </v-btn>
      </div>
    </div>
    <template v-if="!showCount">
      <v-expand-transition>
        <v-card-text
          v-show="post.showExplanation"
          class="pa-0"
        >
          <v-divider />
          <div class="post-card__more-content px-4 py-2">
            <div class="font-weight-bold">
              {{ post.title }}
            </div>
            <div class="post-card__explanation mt-2">
              {{ post.explanation }}
            </div>
          </div>
        </v-card-text>
      </v-expand-transition>
    </template>
    <template v-else>
      <v-divider />
      <v-card-text class="py-2">
        <div class="post-card__more-content">
          <v-expand-transition>
            <div v-show="post.showExplanation">
              <div class="font-weight-bold">
                {{ post.title }}
              </div>
              <div class="post-card__explanation mt-2 pb-2">
                {{ post.explanation }}
              </div>
            </div>
          </v-expand-transition>
          <div class="post-card__play-count d-inline-flex align-center mr-5">
            <v-icon
              small
              class="ml-0 mr-2"
            >
              fas fa-headphones-alt
            </v-icon>
            <span>{{ $_convertNumFormat(post.playCount) }} 回再生</span>
          </div>
          <div class="d-inline-flex align-center">
            <v-icon
              small
              class="ml-0 mr-2"
            >
              far fa-star
            </v-icon>
            <span>{{ $_convertNumFormat(post.favCount) }}</span>
          </div>
        </div>
      </v-card-text>
    </template>
  </v-card>
</template>

<style lang="scss">
.show-count {
  min-height: 103px;
}
.post-card {
  > .d-flex {
    min-height: 62px;
  }
  .post-card__content {
    width: 0;
  }
  .post-card__play-btn {
    height: auto !important;
  }
  .post-card__more-content {
    width: 100%;

    .post-card__explanation {
      white-space: pre-line;
    }
    .post-card__play-count {
      width: 110px;
    }
  }
}
</style>

<script>
export default {
  name: 'PostCard',
  props: {
    noPost: {
      type: Boolean,
      default: false
    },
    loader: {
      type: Boolean,
      default: false
    },
    post: {
      type: Object,
      default: () => ({})
    },
    showUser: {
      type: Boolean,
      default: true
    },
    showCount: {
      type: Boolean,
      default: true
    }
  }
};
</script>
